<app-sub-header [title]="'MyDataTitle' | translate"></app-sub-header>
<div
  class="background"
  style="height: 100%; background: #fffbff; padding-top: 30px"
>
  <div *ngIf="loading" class="spinner">
    <mat-spinner></mat-spinner>
  </div>

  <div
    *ngIf="!loading"
    style="background: #fff; max-width: 750px; min-width: 400px; margin: 0 auto"
  >
    <div class="container user-data-content">
      <form #myForm="ngForm" [formGroup]="userForm">
        <div class="user-data-header">
          <svg
            class="mr-2"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <circle cx="20" cy="20" r="20" fill="#5B43D9" />
            <text
              x="50%"
              y="50%"
              font-size="20"
              fill="white"
              text-anchor="middle"
              alignment-baseline="central"
            >
              {{ getInitials(user.name) }}
            </text>
          </svg>
          <input
            style="width: 300px"
            class="col-sm-2"
            type="text"
            [readonly]="!isEditing"
            class="form-control-plaintext"
            id="inputName"
            formControlName="name"
            [ngClass]="{ 'name-input': isEditing }"
          />

          <!-- <span class="ml-2">{{user.name}}</span> -->
        </div>
        <div class="container" style="padding: 25px">
          <div class="form-group row">
            <label for="staticGenero" class="col-sm-2 col-form-label">
              {{ "MyDataGender" | translate }}
            </label>
            <div class="col-sm-5">
              <span *ngIf="!isEditing">{{ translateGender(user.gender) }}</span>
              <div class="select__wrapper" [class.active]="isEditing">
                <select
                  *ngIf="isEditing"
                  [disabled]="!isEditing"
                  formControlName="gender"
                  required
                >
                  <option value="WOMAN_CIS">
                    {{ "MyDataGenderCisWoman" | translate }}
                  </option>
                  <option value="WOMAN_TRANS">
                    {{ "MyDataGenderTransWoman" | translate }}
                  </option>
                  <option value="MAN_CIS">
                    {{ "MyDataGenderCisMan" | translate }}
                  </option>
                  <option value="MAN_TRANS">
                    {{ "MyDataGenderTransMan" | translate }}
                  </option>
                  <option value="NON_BINARY">
                    {{ "MyDataGenderNonBinary" | translate }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="inputNumero" class="col-sm-2 col-form-label">
              {{ "MyDataNumber" | translate }}
            </label>
            <div class="col-sm-5">
              <input
                type="text"
                [readonly]="true"
                [ngClass]="{
                  'form-control': false,
                  'form-control-plaintext': true
                }"
                id="inputNumero"
                formControlName="phone"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="inputEmail" class="col-sm-2 col-form-label">
              {{ "MyDataEmail" | translate }}
            </label>
            <div class="col-sm-8">
              <input
                type="email"
                [readonly]="true"
                [ngClass]="{
                  'form-control': false,
                  'form-control-plaintext': true
                }"
                id="inputEmail"
                formControlName="email"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="inputFuncao" class="col-sm-2 col-form-label">
              {{ "MyDataRole" | translate }}
            </label>
            <div class="col-sm-10">
              <span class="user-data-content-function">{{ user.role }}</span>
            </div>
          </div>
          <div
            *ngIf="!isEditing"
            class="form-group row mt-4"
            style="float: right"
          >
            <button
              (click)="isEditing = !isEditing"
              class="btn-edit-profile m-1"
            >
              <img src="assets/icons/pencil.svg" alt="" />
              <span>
                {{ "MyDataEditProfile" | translate }}
              </span>
            </button>
            <button (click)="goToChangePasswordPage()" class="btn-primary m-1">
              {{ "MyDataChangePassword" | translate }}
            </button>
          </div>
          <div
            *ngIf="isEditing"
            class="form-group row mt-4"
            style="float: right"
          >
            <button
              (click)="isEditing = !isEditing; resetForm(myForm)"
              class="btn-edit-profile m-1"
            >
              <span>
                {{ "MyDataCancel" | translate }}
              </span>
            </button>
            <button (click)="editUser()" class="btn-primary m-1">
              {{ "MyDataSaveChanges" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
